"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeProgressStyles = void 0;

var makeProgressStyles = function makeProgressStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          "&.DhigProgress--background": {
            color: tokens.colors["detail-1-40-transparent"].rgb
          },
          "&.DhigProgress--foreground": {
            color: tokens.colors["ink-on-background"].rgb,
            position: "absolute",
            left: 0
          }
        },
        circleIndeterminate: {
          animation: "MuiCircularProgress-keyframes-circular-dash 7200ms ease-in-out infinite"
        },
        indeterminate: {
          animation: "MuiCircularProgress-keyframes-circular-rotate 2.4s linear infinite"
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: "3px",
          "&.DhigProgress--size--small": {
            height: "2px"
          },
          "& + .DhigLinearProgressLabel": {
            display: "flex",
            justifyContent: "space-between",
            marginTop: primitives.spacings[2]
          }
        },
        colorPrimary: {
          backgroundColor: tokens.colors["detail-1-40-transparent"].rgb
        },
        barColorPrimary: {
          backgroundColor: tokens.colors["ink-on-background"].rgb
        },
        bar1Indeterminate: {
          animation: "MuiLinearProgress-keyframes-indeterminate1 3600ms ".concat(primitives.transitions.easing.smooth, " infinite")
        },
        bar2Indeterminate: {
          animation: "MuiLinearProgress-keyframes-indeterminate2 3600ms ".concat(primitives.transitions.easing.smooth, " infinite"),
          opacity: 0
        }
      }
    }
  };
};

exports.makeProgressStyles = makeProgressStyles;